import PropTypes from 'prop-types';
import React from 'react';

import { mapMatchesToDates } from 'modules/Football/utils';
import CollapsibleSection from 'modules/Common/components/CollapsibleSection';
import FootballMatchList from './FootballMatchList';
import FootballMatchRoundList from './FootballMatchRoundList';

import { MATCH_FILTER_EMPTY_MESSAGE } from 'modules/Football/consts';

require('./FootballLiveCompetitionList.scss');

export default function FootballLiveDatesList({ matchList = [], fixturesResults, showCompetitions, messageType = "" }) {

  const mappedDatesMatches = mapMatchesToDates(matchList, fixturesResults) || [];

  return (
    <div>
      <ul>
        {
          mappedDatesMatches.map(({
            id,
            name,
            matchList = []
          }) => (
            <li key={id}>
              <div className="FootballMatchList">
                <CollapsibleSection title={name}>
                  <FootballMatchRoundList {...{matchList, showCompetitions, fixturesResults}}/>
                </CollapsibleSection>
              </div>
            </li>
          ))
        }
      </ul>
      {
        !mappedDatesMatches.length && <div className="football-live-filter-no-match-msg">
          <p>{MATCH_FILTER_EMPTY_MESSAGE[`${fixturesResults}${messageType}`]}</p>
        </div>
      }
    </div>
  );
}

FootballLiveDatesList.propTypes = {
  matchList: PropTypes.array.isRequired,
  fixturesResults: PropTypes.string,
  messageType: PropTypes.string,
  showCompetitions: PropTypes.bool
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballLiveDatesList.js